/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, plural: NonNullable<unknown> }} Jobs_Tracked_CountInputs */

const en_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} job${i?.plural} tracked`)
};

const de_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Stelle${i?.plural} verfolgt`)
};

const fr_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} emploi${i?.plural} suivi${i?.plural}`)
};

const es_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} empleo${i?.plural} en seguimiento`)
};

const it_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lavoro${i?.plural} monitorato`)
};

const nl_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} baan${i?.plural} bijgehouden`)
};

const pl_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} oferta${i?.plural} śledzona`)
};

const fi_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} työpaikka${i?.plural} seurannassa`)
};

const da_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} job${i?.plural} sporet`)
};

const sv_jobs_tracked_count = /** @type {(inputs: Jobs_Tracked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} jobb${i?.plural} spårade`)
};

/**
* | output |
* | --- |
* | "{count} job{plural} tracked" |
*
* @param {Jobs_Tracked_CountInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tracked_count = /** @type {((inputs: Jobs_Tracked_CountInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tracked_CountInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tracked_count(inputs)
	if (locale === "fr") return fr_jobs_tracked_count(inputs)
	if (locale === "es") return es_jobs_tracked_count(inputs)
	if (locale === "it") return it_jobs_tracked_count(inputs)
	if (locale === "nl") return nl_jobs_tracked_count(inputs)
	if (locale === "pl") return pl_jobs_tracked_count(inputs)
	if (locale === "fi") return fi_jobs_tracked_count(inputs)
	if (locale === "da") return da_jobs_tracked_count(inputs)
	if (locale === "sv") return sv_jobs_tracked_count(inputs)
	return en_jobs_tracked_count(inputs)
});